import { useAppSelector } from "../app/hooks";
import { selectBooking } from "../features/booking/bookingSlice";
import Button from "./Button";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FormatPrice from "./Helpers/FormatPrice";
import ReservationCard from "./Summary/ReservationCard";
import ProductCard from "./Summary/ProductCard";

interface ICartProps {
  next: () => void;
  buttonText?: string;
}

export function StaticCart({ next, buttonText }: ICartProps) {
  const booking = useAppSelector(selectBooking);
  const location = useLocation();
  const [title, setTitle] = useState<string>("");
  const { t } = useTranslation();
  const [reservations, setReservations] = useState<any[]>([]);

  /**
   * Set title based on route path
   */
  useEffect(() => {
    const path = location.pathname.replace("/", "");
    setTitle(buttonText ?? t(`cart.title.${path}`));
  }, [location.pathname, buttonText, t]);

  useEffect(() => {
    let reservations: any = [];
    booking.Reservations.forEach((reservation, i) => {
      const found = reservations.some((r: any) => {
        return (
          reservation.RoomCategoryId === r.RoomCategoryId &&
          reservation.AdultCount === r.AdultCount
        );
      });
      if (!found) {
        let array: any = { ...reservation };
        array.number = i;
        array.count = 1;
        reservations.push(array);
      } else {
        const array = reservations.find((r: any) => {
          return (
            reservation.RoomCategoryId === r.RoomCategoryId &&
            reservation.AdultCount === r.AdultCount
          );
        });
        array.count++;
      }
    });
    setReservations(reservations);
  }, [booking.Reservations]);

  return (
    <>
      <div className="mt-4 bg-custom-100 rounded-xl text-black text-fluid-base flex flex-col w-full p-4 gap-4 divide-y divide-dashed divide-custom-200">
        {reservations &&
          reservations.map(function (reservation, i) {
            return (
              <ReservationCard
                key={i}
                reservation={reservation}
                showRate={false}
                discount={true}
              />
            );
          })}

        {booking.Products &&
          booking.Products.length > 0 &&
          booking.Products.map(function (product, i) {
            return (
              <ProductCard
                key={i}
                product={product}
                nightCount={booking.NightCount}
                peopleCount={booking.PeopleCount}
              />
            );
          })}

        <div className="flex justify-between gap-2 text-fluid-md">
          <span>{t("scenes.summary.total")}</span>
          <FormatPrice price={booking.ReservationPrice.GrossValue} />
        </div>
      </div>

      <div className="mt-4">
        <Button
          text={title}
          onClick={() => next()}
          disabled={
            booking.Reservations.length === 0 ||
            booking.ReservationPrice.State === "loading"
          }
        />
      </div>
    </>
  );
}
